import { useTheme } from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export function Restricted() {
  const theme = useTheme();
  const { t } = useTranslation('account');

  return (
    <Stack spacing={3} alignItems="center" justifyContent="center" flex={1}>
      <Stack p={2} sx={{ borderRadius: '50%', border: '1px solid white' }}>
        <theme.icons.lock fontSize="large" />
      </Stack>
      <Typography>{t('text.You are not yet friends with this account')}</Typography>
    </Stack>
  );
}
